<section class="animation-effects" [ngClass]="{ animate: showAnimation }">
  <div class="content">
    @if (!enableDonation) {
      <section class="home-alert">
        <div class="cmnh-callout cmnh-callout--error">
          <svg
            class="cmnh-callout__icon cmnh-callout__icon--error"
            aria-hidden="true"
            viewBox="0 0 24 24"
          >
            <path d="M11 7h2v7h-2V7Zm0 9h2v2h-2v-2Z" />
            <path
              fill-rule="evenodd"
              d="M7.76 2h8.48L22 7.76v8.48L16.24 22H7.76L2 16.24V7.76L7.76 2Zm.83 2L4 8.59v6.82L8.59 20h6.82L20 15.41V8.59L15.41 4H8.59Z"
              clip-rule="evenodd"
            />
          </svg>
          <span>{{ "DONATIONS_NOT_ALLOWED" | translate }}</span>
        </div>
      </section>
    }

    <div [hidden]="!showPage">
      <div class="home-actions">
        <app-cmn-button
          class="splash-donate-button-wrapper"
          type="button"
          variant="primary"
          size="large"
          buttonClass="splash-donate-btn"
          [hidden]="!enableDonation"
          [disabled]="!enableDonation"
          (buttonClick)="donate()"
        >
          {{ "DONATE" | translate }}
        </app-cmn-button>

        <app-cmn-button
          class="splash-donate-button-wrapper"
          type="button"
          variant="secondary"
          size="large"
          buttonClass="splash-donate-btn"
          [hidden]="enableDonation"
          [disabled]="enableDonation"
        >
          {{ "DONATIONS_NOT_ALLOWED" | translate }}
        </app-cmn-button>
      </div>
      <div class="splash-campaign-image-wrap">
        <img
          (error)="toggleImage(false)"
          [src]="imageUrl"
          [hidden]="hideImage"
          alt="campaign image"
          class="splash-campaign-image"
        />
      </div>
    </div>
  </div>
</section>